import React from 'react'
import PropTypes from 'prop-types'
import { urlHelpers } from '../../helpers'

/**
* Displays a taxon card.
*/
class TaxonCard extends React.Component {
  constructor(props) {
    super(props)

    this.getTaxonLink = this.getTaxonLink.bind(this)

    this.renderPlaceholder = this.renderPlaceholder.bind(this)
    this.renderTaxonImage = this.renderTaxonImage.bind(this)
  }

  /**
  * Returns the link to the taxon. Returns the empty string if the taxon
  * doesn't have a slug.
  *
  * @returns {string}
  */
  getTaxonLink() {
    if (!this.props.taxon.permalink && !this.props.taxon.linkOverride) {
      return ''
    }
    const ref = this.props.listName ? `taxon-card-${this.props.listName}` : 'taxon-card'


    const permalink = this.props.taxon.linkOverride ? this.props.taxon.linkOverride : `/t/${this.props.taxon.permalink}`

    return urlHelpers.addRef(permalink, ref)
  }

  /**
  * Renders a placeholder of a taxon card.
  */
  renderPlaceholder() {
    return (
      <div className="taxon-card is-placeholder">
        <figure />
        <div />
      </div>
    )
  }

  /**
  * Renders the taxon image.
  */
  renderTaxonImage() {
    // For the image use either the override image or the default display image.
    const imageURL = this.props.taxon.image ? this.props.taxon.image.url : this.props.taxon.display_image_url

    return (
      <figure>
        { imageURL ? (
          <img
            data-original={imageURL}
            className="is-lazy"
            data-fallback-text={this.props.taxon.name}
          />
          ) : (
            <span className="taxon-fallback">{ this.props.taxon.name }</span>
          )
        }
      </figure>
    )
  }

  render() {
    if (this.props.loading) {
      return this.renderPlaceholder()
    }

    return (
      <a
        href={this.getTaxonLink()}
        aria-label={this.props.taxon.name}
        className="taxon-card is-loaded"
      >
        { this.renderTaxonImage() }
        <div className="can-override-text">
          { this.props.taxon.name }
        </div>
      </a>
    )
  }
}

TaxonCard.defaultProps = {
  taxon: {},
  listName: '',
  loading: false,
}

TaxonCard.propTypes = {
  taxon: PropTypes.object,
  listName: PropTypes.string,
  loading: PropTypes.bool,
}

export default TaxonCard
